import styles from './VProcessingPayment.module.css'
import { useState, useEffect } from 'react';
// API
import { useCreateRepairOrderMutation } from "../../../../../../features/services/servicesApiSlice";

// Modal
import { useModalWindow } from "react-modal-global";
import useScrollBlock from "../../../../../../customHooks/useScrollBlock";
import PopupAppearLayout from "../../../../common/Modals/Layouts/PopupAppearLayout";

const VProcessingPayment = () => {
    const [submitStatus, setSubmitStatus] = useState('loading'); // 'loading', 'success', 'error'
    const [errorMessage, setErrorMessage] = useState('');
    const [orderData, setOrderData] = useState(null);

    const [createRepairOrder] = useCreateRepairOrderMutation();

    const modal = useModalWindow();
    const [blockScroll, allowScroll] = useScrollBlock();
    const closeModal = () => {
        allowScroll()
        modal.close()
    } 

    // Получаем данные заказа из параметров модального окна
    useEffect(() => {
        if (modal.params?.orderData) {
            setOrderData(modal.params.orderData);
            processPayment(modal.params.orderData);
        }
    }, [modal.params]);

    const processPayment = async (formData) => {
        try {
            setSubmitStatus('loading');
            setErrorMessage('');

            console.log('Отправляем данные на сервер:', formData);

            // Запускаем запрос и минимальную задержку параллельно
            const [result] = await Promise.all([
                createRepairOrder(formData).unwrap(),
                new Promise(resolve => setTimeout(resolve, 800)) // минимум 800ms показа загрузки
            ]);
            
            console.log('Ответ сервера:', result);
            
            // Проверяем наличие paymentUrl в ответе
            if (result.success && result.data?.paymentUrl) {
                console.log('Перенаправляем на оплату:', result.data.paymentUrl);
                
                // Вызываем функцию сброса формы при успехе (если передана)
                if (modal.params?.onSuccess) {
                    modal.params.onSuccess();
                }
                
                // Закрываем модальное окно
                closeModal();
                
                // Перенаправляем на страницу оплаты
                window.location.href = result.data.paymentUrl;
            } else {
                // Если нет paymentUrl, показываем сообщение об ошибке
                setSubmitStatus('error');
                setErrorMessage('Не удалось получить ссылку для оплаты. Попробуйте снова.');
            }

        } catch (error) {
            console.error('Ошибка при отправке заказа:', error);
            setSubmitStatus('error');
            
            // Обрабатываем разные типы ошибок
            if (error?.data?.message) {
                setErrorMessage(error.data.message);
            } else if (error?.message) {
                setErrorMessage(error.message);
            } else {
                setErrorMessage('Произошла ошибка при обработке платежа. Попробуйте снова.');
            }
        }
    }

    const handleRetry = () => {
        if (orderData) {
            processPayment(orderData);
        }
    }

    return (
        <PopupAppearLayout classNameLayout={styles.popup__layout}>
            <div className={styles.container}>
                <div className={styles.header_container}>
                    <div className={styles.header_title}>
                        <p>Обработка платежа</p>
                    </div>
                    
                    {submitStatus !== 'loading' && (
                        <button
                            className={styles.popup_layout__close}
                            type="button"
                            onClick={closeModal}
                        >
                            &#9587;
                        </button>
                    )}
                </div>

                <div className={styles.content}>
                    {submitStatus === 'loading' && (
                        <div className={styles.status_loading}>
                            <div className={styles.spinner}></div>
                            <h3>Обработка платежа...</h3>
                            <p>Пожалуйста, подождите. Мы обрабатываем ваш заказ.</p>
                        </div>
                    )}

                    {submitStatus === 'error' && (
                        <div className={styles.status_error}>
                            <div className={styles.error_icon}>❌</div>
                            <h3>Ошибка обработки платежа</h3>
                            <p>{errorMessage}</p>
                            <div className={styles.btn_block}>
                                <button 
                                    onClick={handleRetry} 
                                    className={styles.btn_retry}
                                >
                                    Попробовать снова
                                </button>
                                <button 
                                    onClick={closeModal} 
                                    className={styles.btn_close}
                                >
                                    Закрыть
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </PopupAppearLayout>
    );   
}

export default VProcessingPayment;
